'use es6';

import { combineReducers } from 'redux';
import { ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE } from 'DesignData/actions/ActionTypes';

const marketplaceListings = (state = [], action) => {
  switch (action.type) {
    case ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE:
      {
        const {
          result,
          error
        } = action;
        if (error || !result || !result.length) return state;
        const offeringSourceIds = result.map(offeringData => {
          return offeringData.offering.sourceId;
        });
        return offeringSourceIds;
      }

    default:
      return state;
  }
};

export default combineReducers({
  marketplaceListings
});